<template>
     <div class="uk-panel uk-panel-box uk-panel-box-secondary uk-margin-top uk-panel-box-shadow">    
      <h3><span class="ipp-icon ipp-icon-lightbulb"></span> {{$t('common.helpful_hints')}}</h3>
      <hr>
      <div class="uk-panel">  
        <ul>
        <li v-for="item in $t('bottomtips')" class="uk-margin-small-top uk-margin-small-bottom  uk-h5">
         {{ item }} 
        </li>  
        </ul>      	
      	<!-- <p v-for="item in $t('bottomtips')" class="uk-margin-small-top uk-margin-small-bottom  uk-h5">        		
      		<i class="uk-icon-circle"></i> {{ item }} 
      	</p> -->
      </div>            
    </div>
</template>
<script>
export default {
  name: 'tips'
}
</script>



// WEBPACK FOOTER //
// src/components/information/tips.vue